var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketAnalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17H23.0948",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3209 8.44278V12.8852C19.3202 13.2487 19.1755 13.5972 18.9184 13.8543C18.6613 14.1113 18.3129 14.2561 17.9493 14.2568H5.60488C5.24132 14.2561 4.89286 14.1113 4.63579 13.8543C4.37871 13.5972 4.23398 13.2487 4.23328 12.8852V4.20546C4.23328 3.84169 4.37778 3.49282 4.63501 3.2356C4.89223 2.97837 5.24111 2.83386 5.60488 2.83386H15.1928",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2234 2.82855C15.9746 3.33688 15.8633 3.90149 15.9004 4.46621C15.9376 5.03094 16.1219 5.57609 16.4352 6.04744C16.7484 6.5188 17.1796 6.89991 17.6859 7.15288C18.1922 7.40585 18.7558 7.52184 19.3209 7.48934",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1499 16.0838H10.4067L10.6358 14.2568H12.9209L13.1499 16.0838Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5216 16.9893H9.03516C9.03795 16.7487 9.13535 16.5187 9.30629 16.3493C9.47723 16.1799 9.70798 16.0845 9.94867 16.0838H13.6054C13.8465 16.0838 14.078 16.1788 14.2495 16.3484C14.421 16.5179 14.5188 16.7482 14.5216 16.9893V16.9893Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9493 14.2568C18.3129 14.2561 18.6613 14.1114 18.9184 13.8543C19.1755 13.5972 19.3202 13.2488 19.3209 12.8852V12.4271H4.23596V12.8852C4.23596 13.249 4.38047 13.5979 4.63769 13.8551C4.89492 14.1123 5.24379 14.2568 5.60756 14.2568H17.9493Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7594 8.84494C24.8264 8.91209 24.8795 8.99178 24.9156 9.07945C24.9518 9.16712 24.9704 9.26106 24.9703 9.3559C24.9701 9.45075 24.9513 9.54464 24.9149 9.63222C24.8785 9.71979 24.8252 9.79934 24.7581 9.86632C24.6909 9.93329 24.6112 9.98639 24.5236 10.0226C24.4359 10.0588 24.3419 10.0773 24.2471 10.0772C24.1523 10.0771 24.0584 10.0583 23.9708 10.0218C23.8832 9.98544 23.8037 9.93214 23.7367 9.86499L22.0908 8.21906C22.0205 8.14823 21.9811 8.0525 21.9811 7.95273C21.9811 7.85296 22.0205 7.75724 22.0908 7.6864L22.5728 7.19902C22.6438 7.12868 22.7392 7.08859 22.8392 7.08716C22.9392 7.08774 23.035 7.12796 23.1055 7.19902L24.7594 8.84494Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.586 7.18307L22.104 7.66779H22.088L21.1798 6.76227C21.3709 6.6138 21.5427 6.44201 21.6912 6.25092L22.586 7.18307Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4382 1.95233C21.1367 1.65043 20.7786 1.41093 20.3844 1.24752C19.9903 1.08411 19.5678 1 19.1411 1C18.7144 1 18.2919 1.08411 17.8977 1.24752C17.5036 1.41093 17.1455 1.65043 16.844 1.95233C16.5874 2.2058 16.3774 2.50239 16.2234 2.82856C15.9746 3.33688 15.8633 3.90149 15.9004 4.46622C15.9376 5.03094 16.1219 5.5761 16.4352 6.04745C16.7484 6.5188 17.1796 6.89992 17.6859 7.15288C18.1922 7.40585 18.7558 7.52185 19.3209 7.48934C19.9949 7.45571 20.641 7.20959 21.1665 6.78623C21.3576 6.63775 21.5294 6.46597 21.6779 6.27487C22.1761 5.65081 22.427 4.86516 22.3828 4.06787C22.3386 3.27058 22.0023 2.51748 21.4382 1.95233ZM20.8017 5.91C20.3812 6.33244 19.8158 6.57907 19.2202 6.59981C18.6246 6.62056 18.0433 6.41386 17.5946 6.02168C17.1458 5.6295 16.8631 5.08124 16.8038 4.4882C16.7445 3.89516 16.9131 3.30179 17.2754 2.82856C17.3364 2.74262 17.405 2.66239 17.4805 2.58886C17.9243 2.1652 18.5163 1.932 19.1298 1.93912C19.7433 1.94625 20.3297 2.19313 20.7635 2.62698C21.1974 3.06083 21.4443 3.64721 21.4514 4.26072C21.4585 4.87424 21.2253 5.46619 20.8017 5.91Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8016 5.91C20.3812 6.33244 19.8158 6.57907 19.2202 6.59981C18.6245 6.62056 18.0433 6.41386 17.5945 6.02168C17.1457 5.6295 16.863 5.08124 16.8038 4.4882C16.7445 3.89516 16.9131 3.30179 17.2754 2.82856C17.3364 2.74262 17.405 2.66239 17.4805 2.58886C17.9243 2.1652 18.5162 1.932 19.1298 1.93912C19.7433 1.94625 20.3296 2.19313 20.7635 2.62698C21.1973 3.06083 21.4442 3.64721 21.4514 4.26072C21.4585 4.87424 21.2253 5.46619 20.8016 5.91Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0635 8.99945H16.8067",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0635 9.91296H16.8067",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0635 10.8265H16.8067",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6359 3.74207V6.93803H13.8318C13.8318 6.09041 13.4951 5.2775 12.8958 4.67814C12.2964 4.07878 11.4835 3.74207 10.6359 3.74207Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4656 5.79814L13.6081 4.65558H14.748",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71971 4.65559C9.08614 4.65403 8.4664 4.84081 7.93922 5.19222C7.41204 5.54362 7.00119 6.04378 6.75887 6.62918C6.51655 7.21458 6.45368 7.85879 6.57827 8.47999C6.70285 9.10118 7.00925 9.67134 7.45856 10.118L9.71971 7.85688V4.65559Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9209 7.85687H9.72497L7.4585 10.118C7.90519 10.5673 8.47534 10.8737 9.09654 10.9983C9.71774 11.1229 10.3619 11.06 10.9473 10.8177C11.5327 10.5754 12.0329 10.1645 12.3843 9.63736C12.7357 9.11017 12.9225 8.49044 12.9209 7.85687V7.85687Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94873 10.142L11.0913 11.5136H12.6919",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89262 7.62781L6.9791 6.02716H5.14941",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7784 13.5324C11.8843 13.5324 11.9702 13.4465 11.9702 13.3406C11.9702 13.2347 11.8843 13.1489 11.7784 13.1489C11.6725 13.1489 11.5867 13.2347 11.5867 13.3406C11.5867 13.4465 11.6725 13.5324 11.7784 13.5324Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketAnalysis);
export default __webpack_public_path__ + "static/media/market-analysis.ce3a7afa99e12e29edbeba867f742fe2.svg";
export { ForwardRef as ReactComponent };